export default __webpack_public_path__ + "static/media/guna.cbff3a6e.jpg";